<template>
  <div class="device06_dimming_wraper device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name z_ellipsis1">{{objData.remark}}</div>

    <div class="content06_wraper content027_wraper">
      <!-- 进度条样式 -->
      <div class="data06_show data_027show">
        <!-- <span>0%</span> -->
        <progress-bar
          v-on:valueChange="valueChange"
          :width="200"
          :maxValue="100"
          :setValue="userControlData.openStateValue"
        >
          <!-- <span slot="sliderTitle">白光:</span> -->
          <span slot="sliderLeftTips">0%</span>
          <span slot="sliderRightTips">100%</span>
        </progress-bar>
        <!-- <span>100%</span> -->
      </div>

      <!-- 控制按钮样式部分 -->
      <div class="device06_btn_wraper">
        <div class="one_btn_06_wraper" @click="device06BtnClickHandle(1)">开/升</div>
        <div class="one_btn_06_wraper" @click="device06BtnClickHandle(3)">停止</div>
        <div class="one_btn_06_wraper" @click="device06BtnClickHandle(2)">关/降</div>
      </div>
    </div>
    <!-- <BUtton @click="btnhandle">按钮</BUtton> -->
  </div>
</template>

<script>
///需要注意的是 点击按钮 openState为开的时候 需要进度条openStateValue是100  为关的时候需要进度条openStateValues是0，停止的时候 进度条保持不变，但是服务端会返回真正的进度值
//拉动进度条的时候 需要把openState 改为4
import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
import ProgressBar from "components/common/progressbar/progress-bar";
export default {
  data() {
    return {
      userControlData: {
        ///用户设置的缓冲数据
        openState: this.objData.openState, ///1开 或 2关 3停 4 百分比
        openStateValue: this.objData.openStateValue, //百分比 0-100
        openStateValue1: this.objData.openStateValue1, ///无用
        openStateValue2: this.objData.openStateValue2 ///无用
      }
    };
  },
  props: {
    objData: Object ///要控制设备的数据
  },
  components: {
    ProgressBar
  },
  methods: {
    device06BtnClickHandle(mode) {
      ///按钮按下
      if (mode === 1) {
        //打开按钮
        this.userControlData.openStateValue = 100; ///进度条变为100
      } else if (mode === 3) {
        //停止按钮
      } else if (mode === 2) {
        //关闭按钮
        this.userControlData.openStateValue = 0; //进度条变为0
      }
      this.userControlData.openState = mode;
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    valueChange(data) {
      ///进度条值改变
      console.log("子组件传回的值" + data);
      if (this.userControlData.openStateValue === data) return;
      this.userControlData.openStateValue = data;
      this.userControlData.openState = 4; ///需要改为百分比控制
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    }
    // btnhandle() {
    //   this.userControlData.openStateValue++;
    // }
  },
  computed: {

  },
  watch: {
    "objData.openState": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openState = val;
      }
    },
    "objData.openStateValue": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue = val;
      }
    }
  }
};
</script>

<style>
.device06_dimming_wraper {
  height: 400px;
}
.data06_show {
  margin-top: 30px;
  margin-bottom: 30px;
}

/* 控制按钮样式部分 */
.device06_btn_wraper {
  width: 100%;
  height: 80px;

  display: flex;
  justify-content: space-around;
  align-items: center;
}
.one_btn_06_wraper {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /* border: 1px solid #f5f5f5; */
  border-radius: 4px;
  background-color: #f5f5f5;
  color: #282828;
}

.one_btn_06_wraper:active {
  background: #a0a3a5;
}
</style>
